module.exports = __webpack_public_path__ + "static/media/banner.db6ed1f1.png";